import React from "react";
import { FormGroup, SortableTable, TableStyle, tableStyles } from "@velaro/velaro-component-lib";
import { Toggle } from "@/components/Toggle";
import { SiteSettings } from "../types";
import useUsers from "@/hooks/useUsers";

const columns = [
  { label: "Action", accessor: "action" },
  { label: "Billing", accessor: "billing" },
  { label: "Viewer", accessor: "viewer" },
  { label: "Agent", accessor: "agent" },
  { label: "Manager", accessor: "manager" },
  { label: "Administrator", accessor: "administrator" }
];

interface UserAccessSettingsProps {
  siteSettings: SiteSettings;
  setSiteSettings: (updater: React.SetStateAction<SiteSettings>) => void;
  isVisible: (text: string) => boolean;
}

export default function UserAccessSettings({
  siteSettings,
  setSiteSettings,
  isVisible,
}: UserAccessSettingsProps) {
  const { users } = useUsers();

  // State for all toggles
  const [manageLicensesAdmin, setManageLicensesAdmin] = React.useState(true);
  const [accessBillingBilling, setAccessBillingBilling] = React.useState(true);
  const [accessBillingAdmin, setAccessBillingAdmin] = React.useState(true);
  const [setPermissionsManager, setSetPermissionsManager] = React.useState(true);
  const [setPermissionsAdmin, setSetPermissionsAdmin] = React.useState(true);
  const [setDataStorageManager, setSetDataStorageManager] = React.useState(true);
  const [setDataStorageAdmin, setSetDataStorageAdmin] = React.useState(true);
  const [viewAuditLogsViewer, setViewAuditLogsViewer] = React.useState(true);
  const [viewAuditLogsManager, setViewAuditLogsManager] = React.useState(true);
  const [viewAuditLogsAdmin, setViewAuditLogsAdmin] = React.useState(true);
  const [updatePasswordManager, setUpdatePasswordManager] = React.useState(true);
  const [updatePasswordAdmin, setUpdatePasswordAdmin] = React.useState(true);
  const [manageIpManager, setManageIpManager] = React.useState(true);
  const [manageIpAdmin, setManageIpAdmin] = React.useState(true);
  const [accessWidgetManager, setAccessWidgetManager] = React.useState(true);
  const [accessWidgetAdmin, setAccessWidgetAdmin] = React.useState(true);

  const tableData = [
    {
      action: "Manage Licenses (Seats)",
      billing: "",
      viewer: "",
      agent: "",
      manager: "",
      administrator: <Toggle toggled={manageLicensesAdmin} changeToggle={() => setManageLicensesAdmin(!manageLicensesAdmin)} />
    },
    {
      action: "Access Billing and Subscription Details",
      billing: <Toggle toggled={accessBillingBilling} changeToggle={() => setAccessBillingBilling(!accessBillingBilling)} />,
      viewer: "",
      agent: "",
      manager: "",
      administrator: <Toggle toggled={accessBillingAdmin} changeToggle={() => setAccessBillingAdmin(!accessBillingAdmin)} />
    },
    {
      action: "Set or Modify System-Wide Permissions",
      billing: "",
      viewer: "",
      agent: "",
      manager: <Toggle toggled={setPermissionsManager} changeToggle={() => setSetPermissionsManager(!setPermissionsManager)} />,
      administrator: <Toggle toggled={setPermissionsAdmin} changeToggle={() => setSetPermissionsAdmin(!setPermissionsAdmin)} />
    },
    {
      action: "Set Data Storage & Privacy",
      billing: "",
      viewer: "",
      agent: "",
      manager: <Toggle toggled={setDataStorageManager} changeToggle={() => setSetDataStorageManager(!setDataStorageManager)} />,
      administrator: <Toggle toggled={setDataStorageAdmin} changeToggle={() => setSetDataStorageAdmin(!setDataStorageAdmin)} />
    },
    {
      action: "View Audit Logs",
      billing: "",
      viewer: <Toggle toggled={viewAuditLogsViewer} changeToggle={() => setViewAuditLogsViewer(!viewAuditLogsViewer)} />,
      agent: "",
      manager: <Toggle toggled={viewAuditLogsManager} changeToggle={() => setViewAuditLogsManager(!viewAuditLogsManager)} />,
      administrator: <Toggle toggled={viewAuditLogsAdmin} changeToggle={() => setViewAuditLogsAdmin(!viewAuditLogsAdmin)} />
    },
    {
      action: "Update Password Policies",
      billing: "",
      viewer: "",
      agent: "",
      manager: <Toggle toggled={updatePasswordManager} changeToggle={() => setUpdatePasswordManager(!updatePasswordManager)} />,
      administrator: <Toggle toggled={updatePasswordAdmin} changeToggle={() => setUpdatePasswordAdmin(!updatePasswordAdmin)} />
    },
    {
      action: "Manage IP Restrictions",
      billing: "",
      viewer: "",
      agent: "",
      manager: <Toggle toggled={manageIpManager} changeToggle={() => setManageIpManager(!manageIpManager)} />,
      administrator: <Toggle toggled={manageIpAdmin} changeToggle={() => setManageIpAdmin(!manageIpAdmin)} />
    },
    {
      action: "Access Widget Designer",
      billing: "",
      viewer: "",
      agent: "",
      manager: <Toggle toggled={accessWidgetManager} changeToggle={() => setAccessWidgetManager(!accessWidgetManager)} />,
      administrator: <Toggle toggled={accessWidgetAdmin} changeToggle={() => setAccessWidgetAdmin(!accessWidgetAdmin)} />
    }
  ];

  return (
    <div className="w-full">
      <div className="mb-6">
        <span className="text-slate-500">
          Manage all your account users permission. Total users{" "}
          <span className="text-black font-medium">{users.length}</span>
        </span>
      </div>

      <div className="mb-4">
        <h3 className="text-lg font-medium text-slate-800">System Settings & Configuration</h3>
      </div>

      <div className="mb-6 user-access-table">
        <SortableTable
          columns={columns}
          tableData={tableData}
          setTableData={() => {}}
          style={tableStyles.half as TableStyle}
        />
      </div>

    </div>
  );
}